export default {
  name: 'imprint',
  components: {},
  props: [],
  data () {
    return {}
  },
  computed: {

  },
  mounted () {

  },
  methods: {

  }
}
